import { CSSProperties, ReactElement, ReactNode } from 'react';
import cc from 'classcat';
import './index.less';

type TBadgerops = {
  color?: string;
  count?: ReactNode | string;
  className?: string;
  dot?: boolean;
  offset?: [number, number];
  overflowCount?: number;
  showZero?: boolean;
  size?: 'default' | 'small';
  style?: CSSProperties;
  status?: 'success' | 'processing' | 'default' | 'error' | 'warning';
  text?: ReactNode;
  title?: string;
  children?: ReactElement;
};

export const Badge = ({
  children,
  color,
  count,
  className,
  dot,
  offset,
  overflowCount,
  showZero,
  size,
  status,
  style,
  text,
  title
}: TBadgerops) => {
  let styleOBj = {};

  if (offset?.length) {
    styleOBj = { right: -offset[0], marginTop: offset[1] };
  }

  return (
    <div
      title={title}
      style={style}
      className={`${className ? className : ''} badge__container`}
    >
      {children ? children : null}
      {status || dot ? (
        <sup
          style={{ ...styleOBj, background: color }}
          className={cc([
            'badge__dot',
            {
              [`badge__status--${status}`]: status,
              badge__dot__status: status
            }
          ])}
        ></sup>
      ) : count || (showZero && count == 0) ? (
        <sup
          className={cc([
            'badge__count',
            {
              'badge__count--sm': size === 'small'
            }
          ])}
          style={{ ...styleOBj, background: color }}
        >
          {overflowCount && count && +overflowCount > +count
            ? `${overflowCount}+`
            : count}
        </sup>
      ) : null}
      <span className="badge__text">{text}</span>
    </div>
  );
};
